import { Component, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { Table } from 'primeng/table';
import { ContactService } from 'src/app/private/services/contact.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { CreateContactComponent } from "../../components/contact/create-contact/create-contact.component";
import { DeleteContactComponent } from "../../components/contact/delete-contact/delete-contact.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { CourseService } from 'src/app/private/services/course.service';
import { UsersService } from 'src/app/private/services/users.service';

@Component({
  selector: 'app-contacts',
  imports: [CreateContactComponent, DeleteContactComponent, SharedModule, ToolBarComponent],
  templateUrl: './contacts.component.html',
  styleUrl: './contacts.component.scss'
})
export class ContactsComponent {
  @ViewChild('dt') dataTable!: Table;

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10;
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isCreateContact: boolean = false;
  isUpdateContact: boolean = false;
  isDeleteContact: boolean = false;
  editContactData: any = null;

  // Date filters
  startDate: string = '';
  endDate: string = '';

  // Export items
  exportItems: any[] = [];

  // Filter options
  academicYears: any[] = [];
  batches: any[] = [];
  courses: any[] = [];
  departments: any[] = [];
  users: any[] = [];

  // Selected filters
  selectedAcademicYears: any[] = [];
  selectedBatches: any[] = [];
  selectedCourses: any[] = [];
  selectedDepartments: any[] = [];
  selectedUsers: any[] = [];

  // Pagination
  currentPage: number = 0;

  // Sorting
  sortColumn: string = 'createdAt';
  sortDirection: string = 'DESC';

  items: any[] = [];

  columns: any[] = [
    { field: 'full_name', header: 'Contact Name', sortable: true, type: 'full_name' },
    { field: 'email', header: 'Email', sortable: true },
    { field: 'phone', header: 'Phone' },
    { field: 'gender', header: 'Gender' },
    { field: 'designation', header: 'Designation' },
    { field: 'city', header: 'City' },
    { field: 'state', header: 'State' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  filtersOptions: any[] = [
      { header: 'First Name', value: 'first_name', type: 'text' },
    { header: 'Last Name', value: 'last_name', type: 'text' },
    { header: 'Email', value: 'email', type: 'text' },
    { header: 'Phone', value: 'phone', type: 'text' },
    { header: 'Designation', value: 'designation', type: 'text' },
    { header: 'City', value: 'city', type: 'text' },
    { header: 'State', value: 'state', type: 'text' }
  ];

  menuItems: any[] = [{
    label: 'Options',
    items: [
      {
        label: 'Edit Contact',
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          this.isUpdateContact = true;
        }
      },
      {
        label: 'Delete Contact',
        icon: 'pi pi-fw pi-trash',
        styleClass: 'delete-menu-item',
        command: () => {
          this.isDeleteContact = true;
        }
      }
    ]
  }
  ];

  constructor(
    private api: ContactService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private academicYearService: AcademicYearService,
    private batchService: BatchService,
    private courseApi: CourseService,
    private userApi: UsersService
  ) {

    this.getAllAcademicYears();
    this.getAllBatches();
    this.getAllCourses();
    this.getAllDepartments();
  }

  ngOnInit(): void {
    this.setExportColumns();
  }

  getAllAcademicYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };
    this.academicYearService.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYears = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllBatches() {

    // Load batches for filters
    const param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.batchService.getAllBatches(param).subscribe({
      next: (data) => {
        this.batches = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.courseApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.courses = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }


  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departments = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }


  getAllContacts(searchValue?: string, searchAttribute?: string) {
    let whereClause: any = {
      campus_id: this.localStorage.getCampusId(),
      organization_id: this.localStorage.getOrganizationId()
    };

    // Apply filters
    if (this.selectedAcademicYears.length > 0) {
      whereClause.academic_year_id = this.selectedAcademicYears;
    }

    if (this.selectedBatches.length > 0) {
      whereClause.batch_id = this.selectedBatches;
    }

    if (this.selectedCourses.length > 0) {
      whereClause.course_id = this.selectedCourses;
    }

    if (this.selectedDepartments.length > 0) {
      whereClause.department_id = this.selectedDepartments;
    }

    let param: any = {
      page: this.currentPage,
      limit: this.rows,
      where: whereClause,
      order: {
        col: this.sortColumn,
        dir: this.sortDirection
      },
      filter: null
    };

    // Add search filter
    if (searchValue && searchAttribute) {
      param.filter = {
        [searchAttribute]: searchValue
      };
    }

    // Add date filter
    if (this.startDate && this.endDate) {
      param.startDate = this.startDate;
      param.endDate = this.endDate;
    }

    this.loading = true;
    this.api.getAllContactsWithCount(param).subscribe(
      (data: any) => {
        this.initialLoad = false;
        this.loading = false;
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;

        this.filterArray = [
          { key: 'first_name', value: 'First Name' },
          { key: 'last_name', value: 'Last Name' },
          { key: 'email', value: 'Email' },
          { key: 'phone', value: 'Phone' },
          { key: 'designation', value: 'Designation' },
          { key: 'city', value: 'City' },
          { key: 'state', value: 'State' }
        ];
      },
      (error: any) => {
        this.initialLoad = false;
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: (error.error.message || 'Something went wrong, Please try again later.')
        });
      }
    );
  }

  handleAddContact() {
    this.isCreateContact = true;
    this.editContactData = null;
  }

  saveEditData(rowData: any) {
    this.editContactData = rowData;
  }

  handleCloseDialog(refresh: boolean = false) {
    this.isCreateContact = false;
    this.isUpdateContact = false;
    this.isDeleteContact = false;
    this.editContactData = null;

    // if (refresh) {
    //   this.reloadDataTable();
    // }
  }

  onPageChange(event: any) {
    console.log("page chage", event);
    this.currentPage = (event.first / event.rows) * event.rows;
    this.rows = event.rows;
    this.getAllContacts();
  }

  onSort(event: any) {
    this.sortColumn = event.field;
    this.sortDirection = event.order === 1 ? 'ASC' : 'DESC';
    this.getAllContacts();
  }

  onFilterChange() {
    this.currentPage = 0;
    this.getAllContacts();
  }


  handleSearch(event: any) {
    console.log(event);
    this.getAllContacts(event.value, event.selectedFilterAttribute);
  }

  handleDateFilter(event: any) {
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.getAllContacts();
    } else {
      this.startDate = '';
      this.endDate = '';
      this.getAllContacts();
    }
  }

  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.selectedAcademicYears = [];
    this.selectedBatches = [];
    this.selectedCourses = [];
    this.selectedDepartments = [];
    this.currentPage = 0;
    this.rows = 10;
    this.getAllContacts();
  }

  setExportColumns() {
    this.exportItems.push({ label: 'Prefix', value: 'prefix', checked: false });
    this.exportItems.push({ label: 'First Name', value: 'first_name', checked: false });
    this.exportItems.push({ label: 'Middle Name', value: 'middle_name', checked: false });
    this.exportItems.push({ label: 'Last Name', value: 'last_name', checked: false });
    this.exportItems.push({ label: 'Email', value: 'email', checked: false });
    this.exportItems.push({ label: 'Phone', value: 'phone', checked: false });
    this.exportItems.push({ label: 'Gender', value: 'gender', checked: false });
    this.exportItems.push({ label: 'Designation', value: 'designation', checked: false });
    this.exportItems.push({ label: 'City', value: 'city', checked: false });
    this.exportItems.push({ label: 'State', value: 'state', checked: false });
    this.exportItems.push({ label: 'Country', value: 'country', checked: false });
    this.exportItems.push({ label: 'Date of Birth', value: 'date_of_birth', checked: false });
    this.exportItems.push({ label: 'Age', value: 'age', checked: false });
    this.exportItems.push({ label: 'Nationality', value: 'nationality', checked: false });
    this.exportItems.push({ label: 'Address', value: 'address', checked: false });
    this.exportItems.push({ label: 'Postal Code', value: 'postal_code', checked: false });
    this.exportItems.push({ label: 'Alternate Phone', value: 'alternate_phone', checked: false });
    this.exportItems.push({ label: 'Remarks', value: 'remarks', checked: false });
  }

  export(selectedFields: any) {
    let param = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
      },
    };

    this.messageService.add({
      severity: 'info',
      summary: 'Exporting',
      detail: 'Exporting data, please wait...',
      sticky: true
    });

    this.api.getAllContactsWithCount(param).subscribe({
      next: (data: any) => {
        const mappedData = (data.rows || []).map((contact: any) => {
          let row: any = {};

          selectedFields.forEach((field: any) => {
            row[field.label] = contact[field.value] || '';
          });

          return row;
        });

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Contacts');

        // Save the file
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const date = new Date();
        const fileName = `Contacts_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        saveAs(dataBlob, fileName);

        this.messageService.clear();

        this.exportItems.forEach((item) => {
          item.checked = false;
        });
      },
      error: (e) => {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error exporting data'
        });
      },
    });
  }

  getFullName(contact: any) {
    return [contact?.prefix, contact?.first_name, contact?.middle_name, contact?.last_name]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }

  reloadDataTable() {
    this.currentPage = 0;
    this.rows = 10;
    this.getAllContacts();
  }

}
